$(document).on('change', '[data-change="submit"]', function (ev) {
  $(this).parents('form').eq(0).submit();
});